import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import ArtistCardThumb from "./ArtistCardThumb";
import { fmtINRFull } from "../lib/api";
import { track } from "../analytics/tracker";

export default function ArtistListingCard({ artist, testId }) {
  const categories = artist.categories?.length ? artist.categories : [artist.category];
  const categoryLine = categories.filter(Boolean).join(" · ");
  const price = artist.starting_price || artist.base_price;

  return (
    <Link
      to={`/artist/${artist.slug || artist.user_id}`}
      onClick={() => track("artist_card_click", {
        artist_id: artist.user_id,
        category: artist.category,
        city: artist.city,
        source: window.location.pathname === "/" ? "home_section" : "listing",
      })}
      className="artist-card-v2"
      data-testid={testId}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="artist-img-wrap">
        <ArtistCardThumb
          artist={artist}
          className="artist-cover-v2"
          placeholder={<span style={{ fontSize: 64 }}>{artist.emoji || ""}</span>}
        />
        {artist.is_boosted ? (
          <div className="artist-badge boosted">Boosted</div>
        ) : artist.is_featured ? (
          <div className="artist-badge featured">Featured</div>
        ) : artist.plan_code === "elite" ? (
          <div className="artist-badge elite">Elite</div>
        ) : artist.plan_code === "platinum" ? (
          <div className="artist-badge platinum">Platinum</div>
        ) : null}
      </div>
      <div className="artist-listing-body">
        <div className="artist-listing-title-row">
          <span className="artist-listing-name">
            {artist.stage_name}
            {artist.verified_badge && <span className="artist-listing-verified" aria-label="Verified artist">✓</span>}
          </span>
        </div>
        <div className="artist-listing-category">
          {categoryLine && <span className="artist-listing-type">{categoryLine}</span>}
          {categoryLine && artist.city && " · "}
          {artist.city}
        </div>
        <div className="artist-listing-footer">
          <div>
            <div className="artist-listing-price-label">From</div>
            <div className="artist-listing-price">{price ? fmtINRFull(price) : "Contact for price"}</div>
          </div>
          <span className="artist-listing-arrow" aria-hidden="true">
            <ArrowRight size={18} />
          </span>
        </div>
      </div>
    </Link>
  );
}
